import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/style.css';
import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducers'; // Importe o seu reducer raiz
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';

const store = configureStore({
  reducer: rootReducer,
  // Adicione outras opções de configuração, se necessário
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
